"use strict";
/**
 * @module Services.TopicUpdate
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Write a {@link NoTopic} update constraint to the stream
 */
function write() {
    // no-op, write nothing
}
exports.write = write;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/topic-update/no-topic-serialiser.js
// module id = 1412
// module chunks = 1